

import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom"; // Added useHistory
import AddClient from "../components/Invoice/AddClient";
import AccountMenuPanel from "../components/Header/AccountMenuPanel";
import PersonAddOutlinedIcon from "@material-ui/icons/PersonAddOutlined";
import HistoryOutlinedIcon from "@material-ui/icons/HistoryOutlined";
import AppsOutlinedIcon from "@material-ui/icons/AppsOutlined";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import AddSupplier from "../components/Suppliers/AddSupplier";
import AddStaff from "../components/Staff/AddStaff";
import DSRDialog from "../components/Invoices/DSRDialog";
import usePermissions from "../utils/permissions";
import PermissionTooltip from "../components/PermissionTooltip/PermissionTooltip";
import * as api from "../api/index";
import { useShift } from "../Context/ShiftContext";
import { useEffectiveProfile } from "../utils/useEffectiveProfile";
import { useSnackbar } from "../utils/useSnackbar";
import { beginLogout, hasUnsavedChanges, LOGOUT_UNSAVED_MESSAGE } from "../utils/logoutGuard";

import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Button, // Added Button
  Avatar, // Added Avatar
  Popper, // Added Popper
  Grow, // Added Grow
  Paper, // Added Paper
  ClickAwayListener, // Added ClickAwayListener
  MenuList, // Added MenuList
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  TextField,
  InputAdornment,
  Divider,
} from "@material-ui/core";
import { AppContext } from "../Context/AppContext";
import { withStyles } from "@material-ui/core/styles";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  SettingsOutlined as SettingsIcon,
  HelpOutline as HelpOutlineIcon,
  AccountCircle as AccountCircleIcon,
  DashboardOutlined as DashboardIcon,
  PieChartOutlined as PieChartIcon,
  Add as AddIcon,
  EventNoteOutlined as EventNoteIcon,
  BarChartOutlined as BarChartIcon,
  PlayCircleFilledWhiteOutlined as PlayCircleFilledIcon,
  StopOutlined as StopIcon,
  PersonAddOutlined as PersonAddIcon,
  EqualizerOutlined as EqualizerIcon,
  StorefrontOutlined as StorefrontIcon,
  ReceiptOutlined as ReceiptIcon,
  AssignmentReturnOutlined as AssignmentReturnIcon,
  ExitToAppOutlined as LogoutIcon,
  VpnKey as VpnKeyIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Security as SecurityIcon,
  HistoryOutlined as HistoryIcon,
  SupervisorAccount as SupervisorAccountIcon,
} from "@material-ui/icons";
import { useDispatch } from "react-redux"; // Added useDispatch
import { getInvoices } from "../actions/invoiceActions";

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));
const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

// Shared by every icon in the toolbar below (Settings, Dashboard, Items,
// Invoices, Stock Summary, ...) - was six copies of the same
// Tooltip > Link > IconButton triplet, each easy to drift out of sync with
// the others. Always renders react-router's <Link> (fast, client-side
// navigation - no full page reload) rather than a plain <a href>, which is
// what "Admin Dashboard" was using before this and silently reloaded the
// whole app on every click.
const NavIconButton = ({
  to,
  title,
  icon: Icon,
  ariaLabel,
  iconColor = "#475569",
  hoverBg = "#f8fafc",
  muiColor,
  disabled = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Link to={to} style={{ textDecoration: "none" }}>
      <Tooltip title={title} arrow>
        <span>
          <IconButton
            aria-label={ariaLabel || title}
            disabled={disabled}
            color={muiColor}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              padding: 6,
              color: disabled ? "#cbd5e1" : iconColor,
              backgroundColor: isHovered && !disabled ? hoverBg : "transparent",
              transform: isHovered && !disabled ? "translateY(-1px) scale(1.05)" : "none",
              transition: "all 0.15s ease",
            }}
          >
            <Icon style={{ fontSize: 20, color: disabled ? "#cbd5e1" : iconColor }} />
          </IconButton>
        </span>
      </Tooltip>
    </Link>
  );
};

const CartHeader = ({ classes, theme, handleDrawerClose, invoices }) => {
  const [anchorEl, setAnchorEl] = useState(null); // For the Add Options menu
  const [openProfile, setOpenProfile] = useState(false); // For the profile dropdown
  const [confirmLogout, setConfirmLogout] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const user = JSON.parse(localStorage.getItem("profile"));
  const isSuperAdminUser = Array.isArray(user?.result?.userType)
    ? user.result.userType.includes("superAdmin")
    : user?.result?.userType === "superAdmin";
  // SuperAdmin's Global Settings > Goods Return entitlement.
  const effectiveProfile = useEffectiveProfile();
  const goodsReturnEnabled = effectiveProfile?.goodsReturnEntitled !== false;
  const [openClient, setOpenClient] = useState(false);
  const [openSupplier, setOpenSupplier] = useState(false);
  const [confirmShiftStart, setConfirmShiftStart] = useState(false);
  const [confirmShiftEnd, setConfirmShiftEnd] = useState(false);
  const [employeesList, setEmployeesList] = useState([]);
  const [lastShiftsByEmployee, setLastShiftsByEmployee] = useState({});
  const [selectedEmployeeForShift, setSelectedEmployeeForShift] = useState("");
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  // No custom options - a leftover pre-react-toastify `style`/zIndex object
  // that's silently ignored now (see ItemCards.js), and the "top-center"
  // position made this the one screen whose toasts appeared somewhere
  // different from the rest of the app. The shared default is bottom-right.
  const [openSnackbar] = useSnackbar();
  const {
    shiftEnabled,
    myActiveShift,
    fetchMyActiveShift,
    startShift,
    endShift,
    shiftLoading,
  } = useShift();

  const {
    loading,
    canUpdatePage,
    canDeletePage,
    canCreatePage,
    canReadPage,
    isAdmin,
    canDownloadReports: canDownloadReportsPermission,
  } = usePermissions();

  // Was: a separate api.getUserPermissions() call re-fetched on every mount
  // of this component (i.e. every time the cart drawer/PoS screen remounts
  // on navigation), duplicating the single shared fetch PermissionsContext
  // already does app-wide - adding a redundant network round trip to every
  // navigation back to this screen. canDownloadReports/isAdmin below are
  // just derived from the shared permissions payload instead.
  const isAdminn = isAdmin();
  const canDownloadReports = canDownloadReportsPermission();

  // Fetch my active shift when on POS (skipped while shift tracking is off).
  useEffect(() => {
    if (!shiftEnabled) return;
    fetchMyActiveShift();
  }, [fetchMyActiveShift, shiftEnabled]);

  const [openStaff, setOpenStaff] = useState(false);
  const {
    openDSR,
    setOpenDSR,
    dateDSR,
    setDateDSR,
    showPreviewDSR,
    setShowPreviewDSR,
  } = useContext(AppContext);
  const dispatch = useDispatch(); // For logout action
  const history = useHistory(); // For navigation
  const anchorRef = React.useRef(null); // Ref for profile button

  // Handlers for Add Options menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Handlers for Profile dropdown
  const handleProfileToggle = () => {
    setOpenProfile((prevOpen) => !prevOpen);
  };
  const handleProfileClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenProfile(false);
  };
  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenProfile(false);
    }
  };
  const openLink = (link) => {
    history.push(`/${link}`);
    setOpenProfile(false);
  };

  const handleGoToSuperAdmin = async () => {
    try {
      await api.recordProgramLogEvent({ event: "SWITCH_TO_SUPERADMIN" });
    } catch (error) {
      // The view switch should still work if audit logging is temporarily down.
      console.warn("Could not record the SuperAdmin view switch", error);
    }
    localStorage.removeItem("superAdminViewingPos");
    setOpenProfile(false);
    // App.js selects its SuperAdmin shell during initial render, so this
    // route change must reload after clearing the POS-view flag.
    window.location.href = "/superadmin";
  };

  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const openChangePasswordDialog = () => {
    setOpenProfile(false); // close the avatar menu behind it
    setPasswordDialogOpen(true);
  };

  const closeChangePasswordDialog = () => {
    setPasswordDialogOpen(false);
    setNewPassword("");
    setConfirmPassword("");
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };

  const handleChangePasswordSubmit = async () => {
    if (!newPassword || newPassword.length < 6) {
      openSnackbar("New password must be at least 6 characters");
      return;
    }
    if (newPassword !== confirmPassword) {
      openSnackbar("New password and confirmation don't match");
      return;
    }
    setIsChangingPassword(true);
    try {
      await api.changeMyPassword(newPassword);
      openSnackbar("Password updated successfully");
      closeChangePasswordDialog();
    } catch (err) {
      openSnackbar(err?.response?.data?.message || "Failed to update password");
    } finally {
      setIsChangingPassword(false);
    }
  };
  const logout = async () => {
    if (loggingOut) return;
    beginLogout();
    setLoggingOut(true);
    try {
      await api.logoutSession();
    } catch (error) {
      // Clear local credentials even when the server is unavailable.
      console.warn("Logout API request failed; completing local logout.", error);
    } finally {
      // Order matters. The LOGOUT dispatch flips App.js to its logged-out
      // branch, which unmounts PersistentPosMainScreen and this component
      // along with it - so these two setStates used to run on an already-dead
      // component ("Can't perform a React state update on an unmounted
      // component"). Closing first also keeps this correct if CartHeader ever
      // outlives the dispatch, where a Dialog left open would leave its
      // backdrop swallowing clicks. They stay ahead of localStorage.clear()
      // too: they re-render this component, and `user` is read from
      // localStorage on every render.
      setConfirmLogout(false);
      setOpenProfile(false);
      localStorage.clear();
      sessionStorage.clear();
      dispatch({ type: "LOGOUT" });
      openSnackbar("Logged out successfully");
      // No reload (was: window.location.href, which forces a full re-fetch/
      // re-parse of the whole JS bundle - white-flash, and would have wiped
      // the toast above before it ever painted). App.js's `user` already
      // derives reactively via useSelector, so a plain history.push is
      // enough - the earlier "two-step race" this avoided only existed
      // between a push AND a reload; removing the reload removes the race,
      // not just the flash.
      history.push("/");
    }
  };

  // Handlers for DSR dialog
  const handleDateChange = (newDate) => {
    setDateDSR(newDate);
    setShowPreviewDSR(false);
  };
  const handleSubmit = () => {
    setShowPreviewDSR(true);
  };
  const handleCloseDSR = () => {
    setOpenDSR(false);
    setShowPreviewDSR(false);
  };

  const handleOpenShiftStartDialog = () => {
    setConfirmShiftStart(true);
    setSelectedEmployeeForShift("");
    setLoadingEmployees(true);
    Promise.all([api.fetchEmployees(), api.getLastShiftByEmployee()])
      .then(([empRes, shiftRes]) => {
        const employees = Array.isArray(empRes.data) ? empRes.data : [];
        setEmployeesList(employees);
        setLastShiftsByEmployee(shiftRes.data || {});
      })
      .catch(() => {
        setEmployeesList([]);
        setLastShiftsByEmployee({});
      })
      .finally(() => setLoadingEmployees(false));
  };

  const formatLastShiftForEmployee = (startTime, endTime) => {
    if (!startTime || !endTime) return "No previous shift";
    const d = new Date(startTime);
    const dateStr = d.toLocaleDateString(undefined, {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    const timeOpt = { hour: "2-digit", minute: "2-digit", hour12: true };
    const start = new Date(startTime).toLocaleTimeString(undefined, timeOpt);
    const end = new Date(endTime).toLocaleTimeString(undefined, timeOpt);
    return `${dateStr} ${start} – ${end}`;
  };

  const lastShiftEntries = Object.entries(lastShiftsByEmployee);
  const mostRecentShiftCart = lastShiftEntries.length
    ? lastShiftEntries.reduce((best, [empId, sh]) => {
        const end = sh?.endTime ? new Date(sh.endTime) : null;
        if (!end) return best;
        if (!best) return { empId, ...sh };
        return end > new Date(best.endTime) ? { empId, ...sh } : best;
      }, null)
    : null;
  const mostRecentEmpNameCart = mostRecentShiftCart
    ? employeesList.find((e) => e._id === mostRecentShiftCart.empId)?.name || "Unknown"
    : null;

  const handleConfirmShiftStart = async () => {
    if (!selectedEmployeeForShift) {
      openSnackbar("Please select an employee");
      return;
    }
    const employee = employeesList.find((e) => e._id === selectedEmployeeForShift);
    if (!employee) {
      openSnackbar("Selected employee not found");
      return;
    }
    const result = await startShift(employee, openSnackbar);
    if (result) {
      setConfirmShiftStart(false);
      setSelectedEmployeeForShift("");
    }
  };

  const handleConfirmShiftEnd = async () => {
    const result = await endShift(openSnackbar);
    if (result) setConfirmShiftEnd(false);
  };

  // Ensure focus returns to button after closing profile menu
  const prevOpen = React.useRef(openProfile);
  React.useEffect(() => {
    if (prevOpen.current === true && openProfile === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = openProfile;
  }, [openProfile]);

  return (
    <>
      <AddClient setOpen={setOpenClient} open={openClient} />
      <AddSupplier setOpen={setOpenSupplier} open={openSupplier} />
      <AddStaff setOpen={setOpenStaff} open={openStaff} />
      <div className={classes.drawerHeader}>
        <Tooltip title="Close Drawer" arrow>
          <IconButton
            onClick={handleDrawerClose}
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              padding: 6,
              color: "#475569",
              transition: "all 0.15s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f1f5f9";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.transform = "none";
            }}
          >
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon style={{ fontSize: 22 }} />
            ) : (
              <ChevronRightIcon style={{ fontSize: 22 }} />
            )}
          </IconButton>
        </Tooltip>

        <NavIconButton
          to="/settings"
          title="Settings"
          ariaLabel="Settings"
          icon={SettingsIcon}
          iconColor="#0284c7"
          hoverBg="#f0f9ff"
        />

        {isAdmin() && (
          <NavIconButton
            to="/admindashboard"
            title="Admin Dashboard"
            ariaLabel="Admin Dashboard"
            icon={DashboardIcon}
            iconColor="#7c3aed"
            hoverBg="#f5f3ff"
          />
        )}

        {(isAdmin() || canReadPage("Dashboard")) && (
          <NavIconButton
            to="/dashboard"
            title="Dashboard"
            ariaLabel="Dashboard"
            icon={PieChartIcon}
            iconColor="#0891b2"
            hoverBg="#ecfeff"
          />
        )}

        {shiftEnabled && (
          <NavIconButton
            to="/employees"
            title="Add Employee"
            ariaLabel="Add Employee"
            icon={PersonAddIcon}
            iconColor="#059669"
            hoverBg="#ecfdf5"
          />
        )}

        <NavIconButton
          to="/ItemsList"
          title="Items"
          ariaLabel="Items"
          icon={StorefrontIcon}
          iconColor="#2563eb"
          hoverBg="#eff6ff"
        />

        <NavIconButton
          to="/invoices"
          title="Invoices"
          ariaLabel="Invoices"
          icon={ReceiptIcon}
          iconColor="#4f46e5"
          hoverBg="#eef2ff"
        />

        {goodsReturnEnabled && (
          <NavIconButton
            to="/goods-returns"
            title="Goods Returns"
            ariaLabel="Goods Returns"
            icon={AssignmentReturnIcon}
            iconColor="#e11d48"
            hoverBg="#fff1f2"
          />
        )}

        {isAdmin() && effectiveProfile?.activityLogsVisible !== false && (
          <NavIconButton
            to="/program-logs"
            title="Program Logs"
            ariaLabel="Program Logs"
            icon={HistoryIcon}
            iconColor="#7c3aed"
            hoverBg="#f5f3ff"
          />
        )}

        <PermissionTooltip
          disabled={loading || (!isAdminn && !canDownloadReports)}
          enabledTitle="Daily Sales Report"
        >
          <IconButton
            aria-controls="customized-menu"
            disabled={loading || (!isAdminn && !canDownloadReports)}
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              padding: 6,
              color: loading || (!isAdminn && !canDownloadReports) ? "#cbd5e1" : "#d97706",
              backgroundColor: "transparent",
              transition: "all 0.15s ease",
              cursor:
                loading || (!isAdminn && !canDownloadReports)
                  ? "not-allowed"
                  : "pointer",
            }}
            onMouseEnter={(e) => {
              if (!loading && (isAdminn || canDownloadReports)) {
                e.currentTarget.style.backgroundColor = "#fffbeb";
                e.currentTarget.style.transform = "translateY(-1px) scale(1.05)";
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.transform = "none";
            }}
            aria-haspopup="true"
            variant="contained"
            onClick={() => {
              // The report needs the full invoice list; POS no longer loads
              // it up front (see PosMainScreen.js), so fetch it on demand.
              dispatch(getInvoices());
              setOpenDSR(true);
            }}
          >
            <EventNoteIcon style={{ fontSize: 20, color: loading || (!isAdminn && !canDownloadReports) ? "#cbd5e1" : "#d97706" }} />
          </IconButton>
        </PermissionTooltip>

        <NavIconButton
          to="/stockDetails"
          title="Stock Summary"
          ariaLabel="Stock Summary"
          icon={EqualizerIcon}
          iconColor="#ea580c"
          hoverBg="#fff7ed"
        />

        <NavIconButton
          to="/reports"
          title="Reports"
          ariaLabel="Reports"
          icon={BarChartIcon}
          iconColor="#9333ea"
          hoverBg="#faf5ff"
          disabled={loading || (!isAdminn && !canDownloadReports)}
        />

        {shiftEnabled &&
          (!myActiveShift ? (
            <Tooltip title="Shift Start" arrow>
              <IconButton
                aria-label="Shift Start"
                onClick={handleOpenShiftStartDialog}
                disabled={shiftLoading}
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  padding: 6,
                  color: "#16a34a",
                  transition: "all 0.15s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#f0fdf4";
                  e.currentTarget.style.transform = "translateY(-1px) scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.transform = "none";
                }}
              >
                <PlayCircleFilledIcon style={{ fontSize: 22, color: "#16a34a" }} />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Shift End" arrow>
              <IconButton
                aria-label="Shift End"
                onClick={() => setConfirmShiftEnd(true)}
                disabled={shiftLoading}
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  padding: 6,
                  color: "#dc2626",
                  transition: "all 0.15s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#fef2f2";
                  e.currentTarget.style.transform = "translateY(-1px) scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.transform = "none";
                }}
              >
                <StopIcon style={{ fontSize: 22, color: "#dc2626" }} />
              </IconButton>
            </Tooltip>
          ))}

        <Dialog
          open={confirmShiftStart}
          onClose={() => setConfirmShiftStart(false)}
          style={{ zIndex: 10000 }}
          PaperProps={{ style: { zIndex: 10000 } }}
        >
          <DialogTitle>Start Shift</DialogTitle>
          <DialogContent>
            <DialogContentText style={{ marginBottom: 8 }}>
              Select employee to start shift.
            </DialogContentText>
            {mostRecentEmpNameCart && mostRecentShiftCart && (
              <div
                style={{
                  marginBottom: 16,
                  padding: "8px 12px",
                  borderRadius: 8,
                  backgroundColor: "#f5f5f5",
                  fontSize: "0.75rem",
                }}
              >
                <div style={{ fontWeight: 600, marginBottom: 2, color: "#333" }}>
                  Last shift
                </div>
                <div style={{ color: "#666" }}>
                  {mostRecentEmpNameCart} →{" "}
                  {formatLastShiftForEmployee(
                    mostRecentShiftCart.startTime,
                    mostRecentShiftCart.endTime
                  )}
                </div>
              </div>
            )}
            {loadingEmployees ? (
              <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
                <CircularProgress size={32} />
              </div>
            ) : (
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="shift-employee-label">Employee</InputLabel>
                <Select
                  labelId="shift-employee-label"
                  value={selectedEmployeeForShift}
                  onChange={(e) => setSelectedEmployeeForShift(e.target.value)}
                  label="Employee"
                  renderValue={(id) => {
                    const emp = employeesList.find((e) => e._id === id);
                    return emp ? `${emp.name}${!emp.active ? " (Inactive)" : ""}` : "";
                  }}
                  MenuProps={{
                    style: { zIndex: 10001 },
                    PaperProps: {
                      style: { zIndex: 10001, maxHeight: 320 },
                    },
                  }}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  {[...employeesList]
                    .sort((a, b) => {
                      const aEnd = lastShiftsByEmployee[a._id]?.endTime;
                      const bEnd = lastShiftsByEmployee[b._id]?.endTime;
                      if (!aEnd && !bEnd) return 0;
                      if (!aEnd) return 1;
                      if (!bEnd) return -1;
                      return new Date(bEnd) - new Date(aEnd);
                    })
                    .map((emp) => {
                      const last = lastShiftsByEmployee[emp._id];
                      const lastShiftStr = formatLastShiftForEmployee(
                        last?.startTime,
                        last?.endTime
                      );
                      return (
                        <MenuItem
                          key={emp._id}
                          value={emp._id}
                          disabled={!emp.active}
                        >
                          <div>
                            <div
                              style={{
                                fontWeight: 500,
                                color: !emp.active ? "#999" : "inherit",
                              }}
                            >
                              {emp.name}
                              {!emp.active && " (Inactive)"}
                            </div>
                            <div style={{ fontSize: "0.75rem", color: "#666", marginTop: 2 }}>
                              Last shift → {lastShiftStr}
                            </div>
                          </div>
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            )}
            {!loadingEmployees && employeesList.length === 0 && (
              <DialogContentText style={{ marginTop: 8, color: "textSecondary" }}>
                No employees. Add in Employee Master.
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmShiftStart(false)}>Cancel</Button>
            <Button
              onClick={handleConfirmShiftStart}
              color="primary"
              variant="contained"
              disabled={
                shiftLoading ||
                !selectedEmployeeForShift ||
                loadingEmployees ||
                !employeesList.find((e) => e._id === selectedEmployeeForShift)?.active
              }
            >
              {shiftLoading ? "Starting…" : "Start"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog 
          open={confirmShiftEnd} 
          onClose={() => setConfirmShiftEnd(false)}
          style={{ zIndex: 10000 }}
          PaperProps={{ style: { zIndex: 10000 } }}
        >
          <DialogTitle>End shift?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you want to end your shift? You will not be able to add items until you start a new shift.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmShiftEnd(false)}>Cancel</Button>
            <Button onClick={handleConfirmShiftEnd} color="primary" variant="contained" disabled={shiftLoading}>
              {shiftLoading ? "Ending…" : "End shift"}
            </Button>
          </DialogActions>
        </Dialog>

        <DSRDialog
          open={openDSR}
          onClose={handleCloseDSR}
          date={dateDSR}
          handleDateChange={handleDateChange}
          handleSubmit={handleSubmit}
          showPreview={showPreviewDSR}
          rows={invoices}
          user={user}
          classes={classes}
        />

        {/* Profile Icon Section (Copied from Header) */}
        {/* Flex row: as a plain block the logout icon and the avatar button
            stacked onto separate lines once the header ran out of width. */}
        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          <Tooltip title="Log out" arrow>
            <IconButton
              aria-label="Log out"
              color="inherit"
              onClick={() => setConfirmLogout(true)}
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                padding: 6,
                color: "#ef4444",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#fee2e2";
                e.currentTarget.style.transform = "translateY(-1px) scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.transform = "none";
              }}
            >
              <LogoutIcon style={{ fontSize: 20, color: "#ef4444" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Profile" arrow>
            <Button
              ref={anchorRef}
              aria-controls={openProfile ? "menu-list-grow" : undefined}
              aria-haspopup="true"
              onClick={handleProfileToggle}
              style={{ minWidth: 36, padding: 0, borderRadius: "50%", marginLeft: 2 }}
            >
              <Avatar
                style={{
                  width: 32,
                  height: 32,
                  backgroundColor: "#fff7ed",
                  color: "#ea580c",
                  border: "1.5px solid #fed7aa",
                  fontWeight: 700,
                  fontSize: "0.85rem",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                }}
              >
                {user?.result?.name?.charAt(0)}
              </Avatar>
            </Button>
          </Tooltip>
          <Popper
            open={openProfile}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            style={{ zIndex: 9999 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper elevation={4} style={{ borderRadius: 12, overflow: "hidden", minWidth: 200 }}>
                  <ClickAwayListener onClickAway={handleProfileClose}>
                    <AccountMenuPanel
                      user={user}
                      onKeyDown={handleListKeyDown}
                      onGuide={() => openLink("help")}
                      onChangePassword={openChangePasswordDialog}
                      onLogout={() => {
                        setOpenProfile(false);
                        setConfirmLogout(true);
                      }}
                      onSuperAdmin={isSuperAdminUser ? handleGoToSuperAdmin : undefined}
                      sections={[
                        {
                          label: "Account",
                          items: [
                            { key: "account", label: "My Account", icon: <AccountCircleIcon />, onClick: () => openLink("account") },
                            { key: "settings", label: "Store Settings", icon: <SettingsOutlinedIcon />, onClick: () => openLink("settings") },
                            { key: "privacy", label: "Privacy Policy", icon: <SecurityIcon />, onClick: () => openLink("Webview/PrivacyPolicy") },
                            { key: "features", label: "All Features", icon: <AppsOutlinedIcon />, onClick: () => openLink("help/features") },
                          ],
                        },
                        {
                          label: "Manage",
                          items: [
                            ...(isAdminn || canReadPage("Dashboard") ? [{ key: "dashboard", label: "Dashboard", icon: <DashboardOutlinedIcon />, onClick: () => openLink("dashboard") }] : []),
                            ...(isAdminn ? [{ key: "adduser", label: "Add User", icon: <PersonAddOutlinedIcon />, onClick: () => openLink("adminDashboard") }] : []),
                            ...(isAdminn && effectiveProfile?.activityLogsVisible !== false ? [{ key: "logs", label: "Activity Logs", icon: <HistoryOutlinedIcon />, onClick: () => openLink("program-logs") }] : []),
                          ],
                        },
                      ]}
                    />
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
        <Dialog
          open={confirmLogout}
          onClose={() => !loggingOut && setConfirmLogout(false)}
          aria-labelledby="logout-dialog-title"
        >
          <DialogTitle id="logout-dialog-title">Log out?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {hasUnsavedChanges()
                ? LOGOUT_UNSAVED_MESSAGE
                : "Are you sure you want to log out of this account?"}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmLogout(false)} disabled={loggingOut}>
              Cancel
            </Button>
            <Button onClick={logout} color="primary" variant="contained" disabled={loggingOut}>
              {loggingOut ? <CircularProgress size={20} /> : "Log out"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={passwordDialogOpen} onClose={closeChangePasswordDialog} maxWidth="xs" fullWidth>
          <DialogTitle style={{ backgroundColor: "#ef7f1a", color: "#fff", display: "flex", alignItems: "center", gap: 8 }}>
            <VpnKeyIcon fontSize="small" />
            Change Password
          </DialogTitle>
          <DialogContent style={{ padding: 24, paddingTop: 20 }}>
            <TextField
              autoFocus
              margin="dense"
              label="New Password"
              type={showNewPassword ? "text" : "password"}
              fullWidth
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              inputProps={{ minLength: 6 }}
              helperText="At least 6 characters"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowNewPassword(!showNewPassword)} edge="end" size="small">
                      {showNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              margin="dense"
              label="Confirm New Password"
              type={showConfirmPassword ? "text" : "password"}
              fullWidth
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end" size="small">
                      {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={closeChangePasswordDialog} disabled={isChangingPassword}>
              Cancel
            </Button>
            <Button
              onClick={handleChangePasswordSubmit}
              variant="contained"
              style={{ backgroundColor: "#ef7f1a", color: "#fff" }}
              disabled={isChangingPassword}
            >
              {isChangingPassword ? <CircularProgress size={20} style={{ color: "#fff" }} /> : "Update Password"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default CartHeader;
